import { render, staticRenderFns } from "./setPerformance.vue?vue&type=template&id=446755f6&scoped=true&"
import script from "./setPerformance.vue?vue&type=script&lang=js&"
export * from "./setPerformance.vue?vue&type=script&lang=js&"
import style0 from "./setPerformance.vue?vue&type=style&index=0&id=446755f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446755f6",
  null
  
)

export default component.exports